module.exports = __webpack_public_path__ + "static/media/message4.2e99c128.png";